module.exports = __webpack_public_path__ + "img/CUB.5442c06f.svg";